import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faProjectDiagram, faUserPlus, faTasks,
  faFileContract, faReceipt, faCreditCard
} from '@fortawesome/free-solid-svg-icons';
import './Features.css';
import mock2Svg from './mock-2.svg';
import mockBannerSvg from './mock-banner.svg';

const features = [
  {
    icon: faProjectDiagram,
    title: 'Track Projects',
    description: 'Keep a track of all your projects in the most simple way.',
    details: [
      'Real-time project tracking',
      'Custom project templates',
      'Progress visualization',
    ],
    color: 'blue',
  },
  {
    icon: faUserPlus,
    title: 'Add Members',
    description: 'Add members to your projects and keep them in sync with the progress.',
    details: [
      'Team collaboration',
      'Role management',
      'Member permissions',
    ],
    color: 'purple',
  },
  {
    icon: faTasks,
    title: 'Assign Tasks',
    description: 'Assign and manage tasks with deadlines and priorities.',
    details: [
      'Task prioritization',
      'Deadline management',
      'Task dependencies',
    ],
    color: 'green',
  },
];

const billingFeatures = [
  {
    icon: faFileContract,
    title: 'Estimates',
    description: 'Create estimates for project costs and send to your clients.',
    details: [
      'Cost estimation',
      'Client proposals',
      'Budget planning',
    ],
    color: 'pink',
  },
  {
    icon: faReceipt,
    title: 'Invoices',
    description: 'Generate professional invoices and download as PDF.',
    details: [
      'PDF generation',
      'Professional templates',
      'Easy downloading',
    ],
    color: 'orange',
  },
  {
    icon: faCreditCard,
    title: 'Payments',
    description: 'Track payments done by clients in the payment section.',
    details: [
      'Payment tracking',
      'Transaction history',
      'Payment status',
    ],
    color: 'teal',
  },
];

const FeatureTabs = ({ features, activeIdx, setActiveIdx }) => (
  <div className="feature-tabs">
    <div className="feature-tabs-list">
      {features.map((f, idx) => (
        <button
          key={f.title}
          className={`feature-tab-btn${activeIdx === idx ? ' active' : ''}`}
          onClick={() => setActiveIdx(idx)}
        >
          <FontAwesomeIcon icon={f.icon} />
          <span>{f.title}</span>
        </button>
      ))}
    </div>
    <div className="feature-tabs-card">
      <div className={`feature-card ${features[activeIdx].color} active`}>
        <div className="feature-header-row">
          <div className="feature-icon-wrap">
            <FontAwesomeIcon icon={features[activeIdx].icon} className="feature-icon" />
          </div>
          <h3 className="feature-title-inline">{features[activeIdx].title}</h3>
        </div>
        <div className="feature-info">
          <p>{features[activeIdx].description}</p>
          <ul className="feature-details">
            {features[activeIdx].details.map((detail, i) => (
              <li key={i}>{detail}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

const Features = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const [activeBillingFeature, setActiveBillingFeature] = useState(0);



  // Listen to scroll for active section


  return (
    <div className="features-root">
      {/* Removed <DotNavigation activeSection={activeSection} onDotClick={handleDotClick} /> */}

      {/* Task Management Section */}
      <section id="task-section" className="features-section">
        <div className="features-content">
          <h1 className="features-title">
            Task Management
            <span className="features-title-accent" />
          </h1>
          <p className="features-subtitle">
            Manage your projects and talent in one system for empowered teams, satisfied clients, and increased profitability.
          </p>
          <FeatureTabs features={features} activeIdx={activeFeature} setActiveIdx={setActiveFeature} />
        </div>
        <div className="features-illustration">
          <img src={mock2Svg} alt="Task Management Illustration" />
          <div className="features-cta-area">
            <button
              className="features-cta-btn"
              onClick={() => window.open('/features', '_blank', 'noopener,noreferrer')}
            >
              See All Features
            </button>
          </div>
        </div>
      </section>

      {/* Billing Management Section */}
      <section id="billing-section" className="features-section">
        <div className="features-illustration">
          <img src={mockBannerSvg} alt="Billing Management Illustration" />
          <div className="features-cta-area">
            <button className="features-cta-btn" onClick={() => window.open('/features', '_blank', 'noopener,noreferrer')}>Learn More</button>
          </div>
        </div>
        <div className="features-content">
          <h1 className="features-title">
            Billing Management
            <span className="features-title-accent" />
          </h1>
          <p className="features-subtitle">
            Streamline your billing process with automated invoicing, estimates, and payment tracking.
          </p>
          <FeatureTabs features={billingFeatures} activeIdx={activeBillingFeature} setActiveIdx={setActiveBillingFeature} />
        </div>
      </section>
    </div>
  );
};

export default Features;
